module.exports = __webpack_public_path__ + "img/logo-karewa-xs.7ed3912c.png";